import { Navigate } from 'react-router-dom';
import { checkEncryptedLocalStorageItem } from './localStorage';
import { NavbarComponents } from '../SharedComponents/NavbarComponents';

export const PrivateRoute = ({ currentTheme, toggleTheme, element, title }) => {
    const isLogin = checkEncryptedLocalStorageItem();
    if (isLogin) {
        return <NavbarComponents currentTheme={currentTheme} title={title} toggleTheme={toggleTheme} component={element} />
        // return element;
    } else {
        return <Navigate to="/login" />;
    }
}

export const PrivateLoginRoute = ({ element }) => {
    const isLogin = checkEncryptedLocalStorageItem();
    if (!isLogin) {
        return element;
    } else {
        return <Navigate to="/" />;
    }
}